export default __webpack_public_path__ + "static/BOM_TOUR_MAY22_NEWCASTLE_Mobile_400x400_30213SA-6c866c76f7eb2b7bbfee95bb019ace6e.jpg";